import { Component } from 'react';
import h from 'react-hyperscript';

const asyncComponent = importComponent => {
  class Async extends Component {
    constructor(props) {
      super(props);

      this.state = { component: null };
    }

    async componentDidMount() {
      const { default: component } = await importComponent();

      this.setState({ component }); // eslint-disable-line react/no-did-mount-set-state
    }

    render() {
      const c = this.state.component;

      return c ? h(c, { ...this.props }) : null;
    }
  }

  return Async;
};

export default asyncComponent;



// WEBPACK FOOTER //
// ./src/components/Async/Async.js